import { useState, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { MdEdit, MdDelete, MdClose, MdOutlineRemoveRedEye } from "react-icons/md";
import { AppContext } from '../../../Context';

export default function QuestionsList({ v, k, setOpen, setquestions, fav, questions }) {

    const { userData, showQuestions } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [showquestion, setshowquestion] = showQuestions;

    //showQuestions:[showquestion, setshowquestion]
    const { t } = useTranslation();
    const regex = /(<([^>]+)>)/gi;
    const question = v?.question?.replace(regex, " ");
    let typeName = t(`task_answer_${v?.type}`);

    function selected(checked) {

        if (checked) {
            setquestions(p => [...p, v]);
        } else {
            setquestions(p => [...p?.filter(r => r?.id != v?.id)]);
        }
        
    }

    function deleteQuestion(data) { 
        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }
        
        setquestions(p => p?.filter(r => r?.id != data));
    }

    let ck = questions?.filter(r => r?.id == v?.id);
    if (ck?.length) {
        ck = true ;
    } else {
        ck = false;
    }


  return (
        <tr>

            <td className='tableNumberTD'>{k}.</td>
            <td className='text-right'>
                <b>{question?.replace(/&nbsp;/g, ' ')}</b>
                
                {/* {v?.type == 1 && 
                <>
                    <p>{v?.answers?.text}</p>
                    <strong className='warningText'>{t("questions_warning_1")}</strong>
                </>
                }
                {v?.type == 2 || v?.type == 3 || v?.type == 4 ? 
                    <p style={{paddingTop:4}}>
                        {v?.answers?.map((v) => {
                            return(
                                <span style={{marginLeft:6, }} className={`tag ${v?.checked ? "red" : "gray"}`}>{v?.answer}</span>
                            );
                        })}
                        
                    </p>
                : false}
                {v?.type == 5 && <p className='answerMissingWords' dangerouslySetInnerHTML={{ __html: v?.answers?.text?.substring(0, 130) }}></p>}
                {v?.type == 6 && <p className='answerMissingWords'>{t("math_aljabra_1")}</p>} */}
            </td>
            <td><span className='tag'>{typeName}</span></td>
            <td>
                {fav ? 
                    <input type='checkbox' className='tableCheck' checked={ck} onChange={(d) => selected(d?.target?.checked)} />
                :
                <>
                        <a onClick={() => setshowquestion(v)} className='btn green'><MdOutlineRemoveRedEye /></a>
                        <a onClick={() => setOpen(v)} className='btn blue'><MdEdit /></a>
                        <a onClick={() => deleteQuestion(v?.id)} className='btn red'><MdDelete /></a>
                    </>
                }
            </td>
        </tr>
  )
}
